export const fr_FR = {
    "LOADER": {
        "CHECK-PRE-EXISTING-RESPONSE": "Vérification de réponses préexistantes",
        "INIT-PRE-EXISTING-DISK": "Chargement des réponses préexistantes à partir du disque",
        "INIT-PRE-EXISTING-HYBRID": "Chargement des réponses préexistantes à partir d'Internet",
        "INIT-NEW-RESPONSE": "Lancement d'une nouvelle réponse"
    },
    "MODULES": {
        "ADMIN": {
            "HEADLINE": "Menu du surveillant",
            "QUIT-HEADLINE": "Quitter l'examen",
            "QUIT-EARLY-HEADLINE": "Quitter le logiciel",
            "LEGEND": {
                "ADMIN": "Administration",
                "IAA": "Aménagements de la procédure d’évaluation",
                "LOG": "Registre"
            },
            "LABEL": {
                "PAUSE": "Mise sur pause autorisée",
                "FONT": "Option de police accessible",
                "ZOOM": "Niveau de zoom",
                "COLOR": "Thème de couleur",
                "VIDEO": "Activation des sous-titres<br> pour les vidéos",
                "RESUME": "Code du surveillant requis pour reprendre l’examen ?",
                "REASON": "Raison",
                "TYPE": "Type",
                "EXTRA-TOTAL-TIME": "Minutes de temps supplémentaire accordées :",
                "CANDIDATE-TOTAL-TIME-LABEL": "Durée totale accordée au candidat :",
                "CANDIDATE-TOTAL-TIME": "{{totalTimeAvailableFormatted }}  (temps écoulé : {{timeElapsed }} ; temps restant : {{timeLeft}})",
                "NEW-CANDIDATE-TOTAL-TIME-LABEL": "Nouvelle durée totale accordée :",
                "NEW-CANDIDATE-TOTAL-TIME": "{{newTotalTimeAvailableFormatted}}",
                "EXPLANATION": "Explication",
                "INVIGILATOR-UNLOCK-CODE": "Code du surveillant",
                "COLOR-THEMES": "Couleur – Thèmes",
                "EXPLANATION-MIN-CHAR":"({{s}} caractères minimum)",
                "FOCUS_LOST-EXPLANATION": "Explication",
                "FOCUS_LOST-EXPLANATION-MIN-CHAR": "({{s}} caractères minimum)"
            },
            "REASON-PLACEHOLDER": "Vous pouvez saisir une note explicative ici.",
            "REASON-PLACEHOLDER-MANDATORY": "Veuillez entrer ici une note explicative",
            "INVIGILATOR_UNLOCK_NOTE": "Veuillez saisir le code du surveillant puis cliquer sur <strong>Déverouiller<strong>.",
            "ERROR": {
                "UNLOCKFAILED": "Code du surveillant incorrect"
            },
            "EVENTLOG_INVIGILATOR_UNLOCK_SUCCESS": "Accès au menu du surveillant réussi",
            "EVENTLOG_INVIGILATOR_UNLOCK_FAILED": "Code du surveillant incorrect",
            "EVENTLOG_INVIGILATOR_UNLOCK_EMPTY": "Champ obligatoire",
            "EVENTLOG_APPLICATION_FOCUS_LOST": "Activité interrompue depuis {{sec}} secondes",
            "EVENTLOG_APPLICATION_FOCUS_LOST_SHORT": "Focus lost Short {{time}} time for {{sec}} seconds",
            "EVENTLOG_APPLICATION_FOCUS_LOST_OVER_THRESHOLD": "Mise au point perdue à court du seuil, {} fois",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_SUCCESS": "Activité interrompue. Code du surveillant correct",
            "EVENTLOG_APPLICATION_FOCUS_LOST_INVIGILATOR_UNLOCK_FAILED": "Activité interrompue. Code du surveillant incorrect",
            "EVENTLOG_APPLICATION_RESUME_BY_CANDIDATE": "Reprise de l’examen activée par le candidat",
            "EVENTLOG_APPLICATION_RESUME_BY_INVIGILATOR": "Reprise de l’examen activée par le surveillant",
            "EVENTLOG_EXTRATIME_DEDUCTED": "{{deducted}} minutes déduites. Nouveau temps total : {{new_total_time}}",
            "EVENTLOG_EXTRATIME_ADD": "{{add}} minutes ajoutées. Nouveau temps total : {{new_total_time}}",
            "EVENTLOG_PAUSE_INVIGILATOR_MENU":"Mise en pause pour accès au menu du surveillant",
            "EVENTLOG_PAUSE_BY_INVIGILATOR":"Examen mis en pause par le surveillant",
            "EVENTLOG_PAUSE_BY_CANDIDATE":"Examen mis en pause par le candidat",
            "EVENTLOG_FINISH_EARLY_BY_INVIGILATOR": "Terminer en avance (surveillant)",
            "EVENTLOG_LEAVE_PACKAGE_BY_INVIGILATOR": "Logiciel quitté par le surveillant",
            "PAUSE": {
                "HEADLINE": "En pause",
                "CONTENT": [
                    "L’examen sur ordinateur a été mis en pause.",
                    "L’intervention d’un surveillant est nécessaire pour reprendre.",
                    "Pour reprendre l’examen sur ordinateur, veuillez appuyer sur le bouton ci-dessous."
                ]
            },
            "ENTERED-CHAR":"{{s}} caractères saisis",
            "ENTERED-CHAR-EMPTY":"0 caractères saisis",
            "QUIT-CONTENT": [
                "Êtes-vous sûr(e) de vouloir quitter ? Cela mettra un terme à l’examen."
            ],
            "QUIT-EARLY-CONTENT": [
                "ATTENTION ! Cette option doit être utilisée en cas de problème technique uniquement. Vous pouvez tenter de régler ce problème en quittant le logiciel et en vous y reconnectant.<br/><br/>",
                "Aucun fichier de réponses ne sera préparé ou traité, ce qui permettra au candidat de se reconnecter au logiciel et de reprendre l’examen là où il s’est arrêté.<br/><br/>",
                "Si vous souhaitez simplement mettre fin à l’examen (car le candidat a fini en avance), veuillez cliquer sur <strong>Annuler</strong> puis sur <strong>Quitter l’examen</strong>. Cette action entraînera la création d’un fichier de réponses final.<br/><br/>",
                "Souhaitez-vous continuer ? Si oui, veuillez confirmer en cliquant sur le bouton <strong>Quitter le logiciel</strong>."
            ],
            "QUIT-EARLY-CONTENT-ISSUE":[
                "ATTENTION ! Des difficultés techniques sont apparues. Vous pouvez tenter de régler ce problème en quittant le logiciel et en vous y reconnectant.<br/><br/>",
                "Aucun fichier de réponses ne sera préparé ou traité, ce qui permettra au candidat de se reconnecter au logiciel et de reprendre l’examen là où il s’est arrêté.<br/><br/>",
            ],
            "QUIT-EARLY-CONFIRM": "Quitter le logiciel",
            "MODAL": {
                "HEADLINE": {
                    "CANDIDATE-PAUSE"               : "Pause",
                    "CANDIDATE-CAN-PAUSE-ACTIVATE"  : "Mise sur pause (Activer)",
                    "CANDIDATE-CAN-PAUSE-DEACTIVATE": "Mise sur pause (Désactiver)",
                    "EXTRA-TIME"                    : "Temps supplémentaire",
                    "VIDEO-SUBTITLE-ACTIVATE"       : "Sous-titres automatiques pour les vidéos (Activer)",
                    "VIDEO-SUBTITLE-DEACTIVATE"     : "Sous-titres automatiques pour les vidéos (Désactiver)"
                }
            },
            "INACTIVITY-TIMEOUT" : {
                "HEADER": "Délai d’inactivité",
                "ASSESSMENT-RUNNING":{
                    "CONTENT": [
                        "Vous êtes inactif/inactive depuis 10 minutes. Vous pouvez cliquer sur <strong>Continuer</strong> ou <strong>Réinitialiser la durée</strong>. Vous pouvez également choisir l’option <strong>Mettre fin à l’examen</strong>."
                    ],
                    "FINISH-EARLY": "Êtes-vous sûr(e) de vouloir quitter l’application ? Cela mettra un terme à l’examen."
                },
                "ASSESSMENT-EXPIRED":{
                    "CONTENT": "Vous êtes inactif/inactive depuis 10 minutes. L’examen est maintenant terminé.",
                    "JOURNAL-EXITS":"Souhaitez-vous remplir le journal ?"
                },
                "UNLOCK-INFO":[
                    "Vous avez choisi de réinitialiser la durée au moment où le candidat s'était arrêté : <strong>{{s}}</strong>. Veuillez saisir le code du surveillant puis cliquer sur <strong>Confirmer</strong> pour confirmer la réinitialisation. Vous pouvez également choisir de cliquer sur <strong>Continuer</strong> pour revenir à l’examen.","",""
                ],
                "UNLOCK-INFO-END-EXAM":"Veuillez saisir un code du surveillant pour mettre un terme à l'examen.",
                "UNLOCK-PLACEHOLDER":"Code du surveillant",
                "RESTART": "Pour reprendre le cours de l’examen à <strong>{{s}}</strong>, veuillez cliquer sur <strong>Confirmer la reprise</strong>.",
                "EXPLANATION-PLACEHOLDER": "Si vous le souhaitez, vous pouvez saisir une note explicative.",
                "EXPLANATION": "Explication",
                "EXPLANATION-MIN-CHAR":"({{s}} caractères minimum)",
                "LOG":{
                    "INACTIVITY-TIMEOUT-START": "Début de la pause due à une période d'inactivité",
                    "INACTIVITY-TIMEOUT-RESET": "Réinitialiser la durée après une pause due à une période d'inactivité",
                    "FINISH-EARLY-BY-INVIGILATOR" : "Terminer l'examen en avance (surveillant)"
                }
            }
        },
        "PWA-START": {
            "OPEN": "Ouvrir",
            "SCAN-QR-CODE": "Scanner le code QR",
            "PACKAGE-TYPE-SPECIMEN": "specimen",
            "PACKAGE-TYPE-SCHOOL": "examen en direct",
            "VALID-FROM-TO": "Valide du {{valid_from|amDateFormat:'MMMM Do YYYY, HH:mm'}} au {{valid_to|amDateFormat:'MMMM Do YYYY, HH:mm'}}",
            "NOT-AVAILABLE": "Non disponible",

            "LOADING-ASSESSMENTS": "Chargement des évaluations...",

            "FIRST-TIME-MESSAGE-1": "C'est la première fois que vous utilisez cette application. Vous n'avez encore chargé aucune évaluation.",
            "FIRST-TIME-MESSAGE-2": "Pour charger une évaluation, vous devez obtenir un code QR pour un package d'évaluation.",
            "FIRST-TIME-MESSAGE-3": "Si vous avez un code QR, vous pouvez le scanner en cliquant sur le bouton \"Scanner le code QR\" ci-dessous.",

            "NO-ASSESSMENTS": "Aucune évaluation n'est actuellement stockée.",

            "QR-HEADLINE": "Scanner le code QR",
            "QR-CANCEL": "Annuler",

            "DOWNLOADING-ASSESSMENT": "Téléchargement de l'évaluation...",
            "DOWNLOADED-ASSESSMENT": "Évaluation téléchargée",
            "UNPACKING-ASSESSMENT": "Décompression de l'évaluation...", 
            "ASSESSMENT-READY": "Évaluation prête",
            "ASSESSMENT-READY-MESSAGE": "L'évaluation a été téléchargée et décompressée avec succès.",
            
            "RETRY-DOWNLOAD": "Réessayer le téléchargement",
            "TRY-ANOTHER-QR-CODE": "Essayer un autre code QR",
            "ERROR-MESSAGE": "Erreur",
            "ERROR-404": "Package d'évaluation introuvable (Erreur {{error_code}}). Cela peut signifier :\n• Le code QR est expiré ou invalide\n• L'évaluation n'est pas encore disponible\n• L'évaluation a été supprimée\n\nSi le problème persiste, veuillez contacter votre coordinateur.",
            "ERROR-NETWORK": "Impossible de se connecter au serveur d'évaluation. Cela peut signifier :\n• Problèmes de connectivité réseau\n• Problèmes de configuration du serveur (CORS)\n• Le serveur pourrait être temporairement indisponible\n\nVeuillez vérifier votre connexion internet et réessayer. Si le problème persiste, contactez le support.",
            "ERROR-INVALID-QR": "Format de code QR invalide. Cela peut signifier :\n• Le code QR n'est pas un code QR d'évaluation IB\n• Le code QR est endommagé ou illisible\n• Le format du code QR n'est pas pris en charge\n\nVeuillez vous assurer que vous scannez un code QR d'évaluation IB valide.",
            "ERROR-INVALID-HOST": "Adresse de serveur invalide détectée. Cela peut signifier :\n• Le code QR pointe vers un serveur incorrect\n• Le code QR provient d'un système différent\n\nVeuillez vous assurer que vous utilisez un code QR fourni par l'IB.",
            "ERROR-GENERIC": "Échec du traitement du code QR ({{error_type}}). Cela peut signifier :\n• Il pourrait y avoir des problèmes de connectivité réseau\n• Le serveur pourrait être temporairement indisponible\n\nVeuillez réessayer. Si le problème persiste, contactez le support.",
            "ERROR-CAMERA-NOT-READABLE": "Erreur d'accès à la caméra. Cela peut signifier :\n• Une autre application utilise la caméra\n• Le matériel de la caméra a rencontré une erreur\n\nVeuillez fermer les autres applications qui pourraient utiliser la caméra et réessayer.",
            "ERROR-CAMERA-NOT-ALLOWED": "Accès à la caméra refusé. Cela peut signifier :\n• L'accès à la caméra a été bloqué dans les paramètres du navigateur\n• Les permissions de la caméra n'ont pas été accordées\n\nVeuillez vérifier les paramètres de votre navigateur et autoriser l'accès à la caméra.",
            "ERROR-PERMISSION-DENIED": "Permission refusée. Veuillez autoriser l'accès à la caméra dans les paramètres de votre navigateur.",
            "SCAN-NEW-CODE": "Scanner un nouveau code",
            "CLOSE": "Fermer",

            "ACCESS-BLOCKED-HEADLINE": "Accès refusé",
            "ACCESS-BLOCKED-NOT_CHROMEOS": "Cette application nécessite un appareil ChromeOS en mode kiosque. Veuillez contacter votre administrateur informatique.",
            "ACCESS-BLOCKED-NOT_KIOSK": "Cet appareil n'est pas en mode kiosque ChromeOS. Veuillez contacter votre administrateur informatique pour vérifier la configuration de l'appareil.",
            "ACCESS-BLOCKED-NO_SCHOOL_CODE": "Aucun code d'établissement n'a été configuré sur cet appareil. Veuillez contacter votre administrateur informatique.",
            "ACCESS-BLOCKED-INVALID_SCHOOL_CODE": "Le code d'établissement configuré sur cet appareil n'est pas valide pour les examens. Veuillez contacter votre administrateur informatique.",
            "DEV-MODE-NOTICE": "Exécution en dehors du mode kiosque ChromeOS. Ceci n'est autorisé qu'en mode développement."
        },
        "WELCOME": {
            "HEADLINE": "Bienvenue dans l’interface de votre examen sur ordinateur du PEI.<br />",
            "HEADLINE-MEDIA": "Bienvenue dans le logiciel contenant les pistes audio du Programme du diplôme. <br>",
            "ISEXPIRED": "Ce progiciel a expiré, il était valide jusqu’au <br /><strong>{{expire_date|amDateFormat:'LLL'}}</strong>.",
            "ISBEGUN": "Ce progiciel n’est pas encore accessible, il pourra être ouvert à partir du <br /><strong>{{begin_date|amDateFormat:'LLL'}}</strong>.",
            "CONTENT": [
                "<em>L'autorisation de reproduire du contenu lorsque celui-ci appartient à des tierces parties et qu'il est protégé par des droits d'auteur a été demandée et accordée si nécessaire et dans la mesure du possible. Des efforts raisonnables ont été déployés pour retrouver les personnes détenant les droits d'auteur, mais si des éléments nécessitant une autorisation ont été inclus par inadvertance, nous nous ferons un plaisir d'y remédier dans les meilleurs délais. Toutes les marques commerciales™ ou déposées® incluses sont utilisées à des fins d'illustration uniquement, et leur utilisation n'implique aucune affiliation avec le Baccalauréat International ni aucune promotion de sa part.</em>",
                "<em>À des fins d'évaluation, toutes les mentions de matériel appartenant à des tiers sont conservées et publiées séparément.<br><br>L’IB ne saurait être tenu pour responsable en cas de problèmes techniques (ou autre) indépendants de sa volonté ou en cas de pertes ou dommages subis à la suite de l’accès ou de l’utilisation de la plateforme sur un ordinateur personnel ou un ordinateur autre que ceux appartenant à l’établissement scolaire.</em>"
            ],
            "SECONDARY_ACCESS_CODE": "Saisir le code d’accès secondaire",
            "SECONDARY_ACCESS_CODE_ERROR": "Vous avez saisi un code d’accès non valide.",
            "INVIGILATOR_LOGIN": "Identifiants de connexion du surveillant"
        },
        "VM-DETECTION": {
          "EVENTLOG-INVIGILATOR-MESSAGE": "Une machine virtuelle a été détectée. L’examen a été déverrouillé par un surveillant.",
          "EVENTLOG-INVIGILATOR-UNLOCK-FAILED": "Le code du surveillant qui a été saisi après la détection d’une machine virtuelle est incorrect.",
          "EVENTLOG-INVIGILATOR-UNLOCK-SUCCESS": "L’examen a été déverrouillé par un surveillant après la détection d’une machine virtuelle.",
          "EVENTLOG-INVIGILATOR-UNLOCK-WRONG-SUCCESS": "Il semble que le code saisi pour déverrouiller l’examen soit le code d’un candidat et non le code d’un surveillant.",
          "HEADLINE": "Machine virtuelle détectée",
          "INFO": "Cela n’est pas autorisé.",
          "INPUT-HEADLINE": "Code du surveillant",
          "INVIGILATOR-CODE": "Saisir le code du surveillant",
          "MESSAGE": "Vous essayez d’exécuter cet examen dans une configuration de \"machine virtuelle\". <br />Cette action doit être autorisée par un surveillant, qui doit saisir son code avant que vous ne puissiez continuer.",
          "MODAL-INVIGILATOR-TEXT-LABEL": "Saisissez un message ou conservez le message par défaut",
          "MODAL-MESSAGE": "Si vous souhaitez autoriser le candidat à continuer malgré le fait qu’il utilise une machine virtuelle, veuillez saisir votre code de surveillant et cliquer sur <strong>Déverrouiller</strong>."
        },
        "LOGIN": {
            "HEADLINE": "Accès à votre examen sur ordinateur",
            "HEADLINE-MEDIA": "Déverrouiller le logiciel contenant les pistes audio",
            "HEADLINE_ENTER_KEY": "Saisissez vos identifiants de connexion",
            "HEADLINE_ENTER_KEY_EXAMINER": "Saisie des identifiants de connexion de l’examinateur",
            "SCHOOL_CODE": "Code de l’établissement",
            "CANDIDATE_CODE": "Code du candidat",
            "UNLOCK_CODE": "Code d'accès",
            "UNLOCKFAILED": "Les identifiants de connexion que vous avez saisis sont incorrects. Veuillez les vérifier puis recommencer. <strong>Remarque</strong> : tous les champs sont sensibles à la casse.",
            "CONTENT": [
                "<em>L'autorisation de reproduire du contenu lorsque celui-ci appartient à des tierces parties et qu'il est protégé par des droits d'auteur a été demandée et accordée si nécessaire et dans la mesure du possible. Des efforts raisonnables ont été déployés pour retrouver les personnes détenant les droits d'auteur, mais si des éléments nécessitant une autorisation ont été inclus par inadvertance, nous nous ferons un plaisir d'y remédier dans les meilleurs délais. Toutes les marques commerciales™ ou déposées® incluses sont utilisées à des fins d'illustration uniquement, et leur utilisation n'implique aucune affiliation avec le Baccalauréat International ni aucune promotion de sa part.</em>",
                "<em>À des fins d'évaluation, toutes les mentions de matériel appartenant à des tiers sont conservées et publiées séparément.<br><br>L’IB ne saurait être tenu pour responsable en cas de problèmes techniques (ou autre) indépendants de sa volonté ou en cas de pertes ou dommages subis à la suite de l’accès ou de l’utilisation de la plateforme sur un ordinateur personnel ou un ordinateur autre que ceux appartenant à l’établissement scolaire.</em>"
            ],
            "EVENTLOG_LOGIN_SUCCESS": "Accès du candidat à l’examen réussi",
            "EVENTLOG_LOGIN_FAILED": "Échec de la tentative d’accès du candidat à l’examen",
            "INVIGILATOR_CODE": "Code du surveillant",
            "EVENTLOG_RELOGIN_HYBRID": "Le candidat a redémarré l’examen après interruption. Réponse restaurée en ligne",
            "EVENTLOG_RELOGIN_DISK": "Le candidat a redémarré l’examen après interruption"
        },
        "HELLOUSER": {
            "WELCOME": {
                "HEADLINE": "Bienvenue à l’examen sur ordinateur de {{taskTitle}}",
                "USER_INFO": " Nous vous avons identifié(e) comme <strong>{{userInfo_completeName}}</strong>,<br />numéro de candidat <strong>{{userInfo_candidateNo}}</strong>, date de naissance <strong>{{userInfo_birthDate}}</strong>.",
                "CONTENT": [
                    "Veuillez confirmer que ces informations sont correctes."
                ]
            },
            "INCORRECT": {
                "HEADLINE": "Informations concernant le candidat incorrectes",
                "CONTENT": [
                    "Vous avez confirmé que vous n&rsquo;êtes pas<strong> {{userInfo_completeName}}</strong>, numéro de candidat <strong>{{userInfo_candidateNo}}</strong>, date de naissance {{userInfo_birthDate}}.",
                    "Cette erreur signifie probablement que le code d&#39;accès que vous avez reçu est incorrect.",
                    "<strong>Veuillez immédiatement contacter votre surveillant.</strong>"
                ]
            },
            "PERSONALDETAILS": {
                "HEADLINE": "Veuillez saisir vos informations personnelles",
                "INPUT": {
                    "FIRSTNAME": {
                        "LABEL": "Prénom",
                        "PLACEHOLDER": "Veuillez saisir votre prénom."
                    },
                    "LASTNAME": {
                        "LABEL": "Nom",
                        "PLACEHOLDER": "Veuillez saisir votre nom."
                    },
                    "SCHOOLCODE": {
                        "LABEL": "Code de l’établissement",
                        "PLACEHOLDER": "Veuillez saisir le code de votre établissement."
                    }
                },
                "FAILED": "Veuillez renseigner tous les champs.",
                "SCHOOLCODE_WARNING_TITLE": "Avertissement",
                "SCHOOLCODE_WARNING_BODY": "L'utilisation d'un code d'établissement incorrect peut entraîner l'impossibilité d'identifier ou de traiter votre réponse. Êtes-vous sûr(e) de vouloir modifier le code de l'établissement ?",
                "SCHOOLCODE_WARNING_CONFIRM": "Modifier le code",
                "SCHOOLCODE_WARNING_CANCEL": "Garder le code actuel",
                "SCHOOLCODE_EDIT_BTN": "Modifier",
                "SCHOOLCODE_NUMERIC_ERROR": "Le code de l'établissement doit être numérique",
                "CONTENT": [
                    ""
                ],
                "BTN_SUBMIT": "Envoyer"
            },
            "RESUME": {
                "HEADLINE": "Veuillez reprendre votre examen sur ordinateur.",
                "CONTENT": "Il semble que vous ayez déjà commencé cet examen sur cet ordinateur.<br />Veuillez noter que le temps que vous avez déjà passé à répondre à cet examen sur ordinateur sera déduit du temps total disponible.<br><strong>Si cela vous semble incorrect, veuillez contacter votre surveillant.</strong>",
                "DIFFERENT_CANDIDATE_HEADLINE": "Données de réponse existantes trouvées",
                "DIFFERENT_CANDIDATE_SUBTITLE": "appartient à un utilisateur qui a précédemment utilisé cet appareil",
                "DIFFERENT_CANDIDATE_CONTENT": "Des données de réponse non terminées se trouvent sur cet appareil.<br/>Vous pouvez reprendre cette session si elle est la vôtre, ou recommencer pour démarrer un nouvel examen.",
                "PREVIOUS_CANDIDATE": "La session a été commencée par : {{name}}",
                "PREVIOUS_CANDIDATE_EMAIL": "La session a été commencée par : {{email}}",
                "CONTINUE_AS": "Continuer en tant que {{name}}",
                "START_OVER": "Supprimer et recommencer",
                "START_OVER_WARNING_TITLE": "Supprimer les données de réponse existantes ?",
                "START_OVER_WARNING_BODY": "Les données de réponse existantes sur cet appareil seront définitivement supprimées et une nouvelle session sera démarrée. Cette action est irréversible.",
                "START_OVER_CONFIRM": "Supprimer et recommencer",
                "BACKUP_FAILED": "Échec de la sauvegarde des données de réponse précédentes. Veuillez réessayer ou contacter un surveillant."
            },
            "CAPTUREEMAIL": {
                "HEADLINE": "Adresse électronique pour les résultats",
                "CONTENT": "Ceci est un spécimen d'épreuve. Veuillez indiquer l'adresse électronique à laquelle vous souhaitez recevoir vos résultats d'évaluation :",
                "INPUT": {
                    "EMAIL": {
                        "LABEL": "Adresse électronique",
                        "PLACEHOLDER": "Veuillez saisir votre adresse électronique"
                    }
                },
                "ERROR": "Veuillez saisir une adresse électronique valide."
            }
        },
        "INSTRUCTIONS": {
            "HEADLINE": "Instructions",
            "CONTENT": [
                "<strong>L’examen sur ordinateur n’a pas encore commencé.</strong><br /><br />",
                "Le temps commencera à être décompté dès que vous cliquerez sur le bouton <strong>Commencer</strong> ci-dessous. Ne cliquez pas sur <strong>Commencer</strong> avant d’y avoir été autorisé(e).<br /><br />",
                "Vous disposez de cinq minutes avant le début de l'examen pour vous familiariser avec sa structure. Veuillez parcourir l'examen en prenant note de la longueur de chaque tâche et de chaque question. ",
                "Vous avez <strong>{{taskTimeFormatted}}</strong> pour réaliser l’examen sur ordinateur.<br /><br />",
                "Cet examen sur ordinateur est composé de <strong>{{numSheets}}</strong> questions distinctes. Chaque question peut comporter des sous-parties. ",
                "Répondez à toutes les questions dans les cases de réponse prévues à cet effet. ",
                "Le nombre maximum de {{marksLabel}} pour cet examen est <strong>{{totalMarks}} {{marksLabel}}</strong>.<br /><br />",
                "Vos réponses aux questions seront enregistrées automatiquement au fur et à mesure de votre progression.<br /><br />",
                "<strong>Une fois les {{ taskTimeFormatted }} écoulées, vous ne pourrez plus répondre aux questions.</strong>"
            ],
            "IAA_PREFERENCES": "Les aménagements de la procédure d'évaluation à des fins d'inclusion suivants ont été appliqués automatiquement suite aux informations contenues dans le dossier vous concernant : ",
            "EVENTLOG_START": "Le candidat a commencé l'examen sur ordinateur.",
            "MINUTES": "minutes",
            "ASSESSMENT-EXPIRED":"Votre durée totale est déjà écoulée. L'examen ne peut pas commencer.",
            "SCREEN_RECORDING_STARTING": "Démarrage de l'enregistrement d'écran...",
            "SCREEN_RECORDING_ERROR_TITLE": "Enregistrement d'écran requis",
            "SCREEN_RECORDING_PERMISSION_DENIED": "L'autorisation d'enregistrement d'écran a été refusée. Vous devez accorder l'autorisation pour continuer.",
            "SCREEN_RECORDING_NOT_SUPPORTED": "L'enregistrement d'écran n'est pas pris en charge dans ce navigateur.",
            "SCREEN_RECORDING_ALREADY_ACTIVE": "L'enregistrement d'écran est déjà actif.",
            "SCREEN_RECORDING_RESTART_FAILED": "Échec du redémarrage de l'enregistrement d'écran. Veuillez réessayer.",
            "SCREEN_RECORDING_UNKNOWN_ERROR": "Une erreur inconnue s'est produite lors du démarrage de l'enregistrement d'écran",
            "SCREEN_RECORDING_PERMISSION_HELP": "Pour accorder l'autorisation d'enregistrement d'écran :",
            "SCREEN_RECORDING_PERMISSION_STEP1": "Cliquez sur le bouton 'Réessayer' ci-dessous",
            "SCREEN_RECORDING_PERMISSION_STEP2": "Lorsque vous y êtes invité, sélectionnez 'Écran entier' ou votre écran spécifique",
            "SCREEN_RECORDING_PERMISSION_STEP3": "Cliquez sur 'Partager' pour accorder l'autorisation",
            "SCREEN_RECORDING_NOT_SUPPORTED_HELP": "Veuillez utiliser un navigateur pris en charge (Chrome, Firefox, Edge) qui prend en charge l'enregistrement d'écran.",
            "SCREEN_RECORDING_RETRY": "Réessayer",
            "SCREEN_RECORDING_MANDATORY": "L'enregistrement d'écran est obligatoire pour cet examen.",
            "SCREEN_RECORDING_CONTACT_ADMIN": "Veuillez contacter votre administrateur d'examen pour obtenir de l'aide."
        },
        "TASKDONE": {
            "HEADLINE": "L’examen est maintenant terminé.",
            "INSTRUCTIONS": "<strong>N’essayez pas de vous déconnecter, d'éteindre ou d’emporter votre ordinateur.</strong><br/><br/>",
            "PACK-RESPONSE": "Collecte des données et préparation des fichiers de réponses",
            "UPLOADING-RESPONSE": "Chargement du fichier de réponses",
            "ATTEMPT": "Tentative",
            "UPLOAD-SUCCESS": "Le fichier de réponses a été chargé avec succès. Vous pouvez maintenant quitter le progiciel.",
            "UPLOAD-PENDING": "Le fichier de réponses n'a pas encore été envoyé à l'IB.",
            "UPLOAD-FAILED": "Un problème est survenu lors du chargement du fichier de réponses. Veuillez réessayer.",
            "RETRYING-UPLOAD": "Le chargement a échoué. Nouvelle tentative automatique en cours...",
            "PACK-FAILED": "L'empaquetage des données de réponse a échoué. Vos données ont été sauvegardées et peuvent être récupérées. Veuillez contacter votre surveillant.",
            "RETRY-UPLOAD": "Réessayer de charger le fichier",
            "TRY-UPLOAD": "Tentative de chargement du fichier de réponses",
            "EXIT": "Quitter",
            "SAVE-TO-FS": "Le fichier de réponses n’a pas pu être chargé automatiquement. Vous pouvez réessayer de charger le fichier de réponses ou quitter et l’envoyer manuellement. Vous trouverez le fichier de réponses dans le dossier « Documents » de cet appareil.",
            "SAVE-TO-FS-BUTTON": "Copier le fichier de réponses dans un autre dossier",
            "DP-MEDIA":{
                "HEADLINE": "L’examen est maintenant terminé",
                "INFO":"L'examen est maintenant terminé.<br/<br>Veuillez écouter les instructions complémentaires du surveillant.<br/><br/>Cette application se fermera automatiquement après 30 secondes."
            }
        },
        "NAVBAR": {
            "SELECT-KEYBOARD-LANG": "Langue du clavier",
            "HIGHLIGHT-TOOL": "Surligner",
            "CALCULATOR": "Calculatrice",
            "DIRECTIVE": {
                "BOOKMARKED": "Questions<br />marquées d’un signet"
            },
            "DIRECTIVEINSTRUCTIONSLONG": "<h4>Informations générales</h4>    <p>        Répondez à toutes les questions dans le temps imparti. Si vous avez le moindre problème pendant l’examen, veuillez lever la main et en informer le surveillant.    </p>  <h4>Navigation</h4>    <p>        <b>Aperçu des questions</b><br />L’espace principal de l’écran d’accueil présente un aperçu de toutes les questions de l’examen. En cliquant sur l’aperçu d’une question, vous ouvrirez la question complète.<br /><br />La question complète comprendra plus d’informations que son aperçu. Veillez donc à bien lire tout le contenu avant de répondre à une question.     </p>    <p>    <b>Menu à droite de l’écran</b><br />Vous trouverez à droite de l’écran un menu contenant une liste de toutes les questions de l’examen.<br /><br />Cliquer sur le numéro d’une question révèlera le nombre de parties dont elle est composée. Cliquer ensuite sur n’importe laquelle des parties entraînera l’ouverture de la question dans la fenêtre principale.    </p>  <h4>Statuts</h4>    <p>        Chaque question peut avoir l’un des trois statuts suivants :    </p><ul><li>Non commencée</li><li>En cours</li><li>Terminée</li></ul> Lorsque vous commencerez l’examen, toutes les questions auront « Non commencée » comme statut. Dès que vous commencerez à répondre à une question, son statut passera automatiquement à « En cours ». Quand vous quitterez une question, son statut passera à « Terminée » (vous pourrez toutefois y revenir à tout moment et modifier votre réponse si vous le souhaitez).<br /><br />   <p><br /></p>",
            "DIRECTIVEINSTRUCTIONSLONG-MEDIA": "<h4>Informations générales</h4><p>En cas de problème, veuillez prévenir votre surveillant.</p><p><br></p>",
            "DIRECTIVEINSTRUCTIONS": {
                "GENERAL": {
                    "HEADLINE": "Informations générales",
                    "CONTENT": ""
                },
                "NAVIGATION": {
                    "HEADLINE": "Navigation",
                    "CONTENT": [
                        "<b>Aperçu des questions</b><br />L’espace principal de l’écran d’accueil présente un aperçu de toutes les questions de l’examen. En cliquant sur l’aperçu d’une question, vous ouvrirez la question complète.<br /><br />La question complète comprendra plus d’informations que son aperçu. Veillez donc à bien lire tout le contenu avant de répondre à une question.",
                        "<b>Menu à droite de l’écran</b><br />Vous trouverez à droite de l’écran un menu contenant une liste de toutes les questions de l’examen.<br /><br />Cliquer sur le numéro d’une question en révèlera les parties. Cliquer sur une partie vous amènera au début de la question."
                    ]
                },
                "STATUSES": {
                    "HEADLINE": "Statuts",
                    "CONTENT": [
                        "Chaque question peut avoir l’un des trois statuts suivants :<ul><li>Non commencée</li><li>En cours</li><li>Terminée</li></ul>Lorsque vous commencerez l’examen, toutes les questions auront « Non commencée » comme statut. Dès que vous commencerez à répondre à une question, son statut passera à « En cours ». Une fois que vous êtes satisfait(e) de votre réponse, vous pouvez en changer le statut et la marquer comme « Terminée » (vous pouvez toutefois à tout moment y revenir et modifier votre réponse si vous le souhaitez).<br /><br />La barre de progression vous donne un aperçu de votre progression dans l’examen en vous indiquant le statut des différentes questions."
                    ]
                }
            },
            "DIRECTIVEQUIT": {
                "HEADLINE": "Veuillez confirmer.",
                "CONTENT": "Êtes-vous sûr(e) de vouloir quitter l’application ? Cela mettra un terme à l’examen."
            },
            "FINISH-EARLY": {
                "HEADLINE": "Avertissement ! Terminer en avance",
                "LABEL": {
                    "LASTNAME": "Nom",
                    "FIRSTNAME": "Prénom"
                },
                "TOOLTIP": {
                    "DISABLED-FINISH-EARLY-BTN": "Uniquement disponible après 60 minutes"
                },
                "WARNING-CONTENT": [
                    "Vous avez décidé de terminer cet examen en avance.",
                    "Si vous continuez, l&#39;examen prendra fin et vous ne pourrez plus y retourner.",
                    "Voulez-vous toujours terminer cet examen en avance ?"
                ],
                "CONFIRM-CONTENT": [
                    "Vous avez confirmé vouloir terminer cet examen en avance.",
                    "Il vous faudra saisir votre nom ci-dessous puis cliquer sur <strong>Terminer en avance</strong>. Vous pouvez également annuler cette action et retourner à l&#39;examen."
                ],
                "JOURNAL-EXITS": "Souhaitez-vous remplir le journal ?"
            }
        },
        "SIDEBAR": {
            "HEADLINE": "Progression",
            "TOOLTIP": {
                "COMPLETE": "signalée comme terminée",
                "COMPLETED": "Terminée",
                "NOTSTARTED": "Non commencée",
                "PARTLY-COMPLETED": "En cours"
            },
            "BUTTONS":{
                "SCROLL-UP": "Question précédente",
                "SCROLL-DOWN": "Question suivante"
            }
        },
        "QUESTION": {
            "HINTOPTION": "Option d’aide",
            "BACKTOOVERVIEW": "Retour à l’aperçu des questions"
        },
        "JOURNAL": {
            "HEADLINE": "Journal",
            "CONTENET": [
                "L'examen est maintenant terminé ; vous êtes invité(e) à répondre à un questionnaire <strong>facultatif</strong> de 10 minutes appelé journal de réflexion. Veuillez utiliser ce journal pour partager votre expérience quant à votre préparation et votre participation à l'examen. Souhaitez-vous remplir le journal ?"
            ],
            "CONFIRM-SAVE": "Êtes-vous sûr(e) de vouloir remplir votre journal ?"
        },
        "SHEET": {
            "READING-TIME": {
                "MODAL": {
                    "HEADLINE": "Temps de lecture",
                    "CONTENT": [
                        "Le temps de lecture est maintenant terminé et votre examen sur ordinateur va bientôt commencer. Veuillez cliquer sur <strong>Commencer</strong> pour continuer."
                    ]
                },
                "OVERLAY": {
                    "LABEL": "Temps de lecture"
                }
            }
        },
        "CHANGELANGUAGE":{
            "LABEL": "Sélectionner la langue du système",
            "LANGUAGES":{
                "EN": "English",
                "ES": "Español",
                "FR": "Français"
            }
        },
        "WIRIS-CKEDITOR-PLUGIN": {
          "BTN-CANCEL": "Annuler",
          "BTN-OK": "Confirmer l’insertion de l’équation",
          "OVERLAY-MSG": "Veuillez saisir votre équation ci-dessous et cliquer sur <strong>Confirmer l’insertion de l’équation</strong>.",
          "SHEET-LEAVE-MSG": "Dans la {{s}}, vous avez commencé à saisir une équation mais ne l’avez pas confirmée. Êtes-vous sûr(e) de vouloir exclure cette équation ? Elle ne sera pas incluse dans votre réponse.",
          "SHEET-LEAVE-TITLE": "Éditeur d’équations"
        },
        "SHEET-LEAVE":{
            "MODAL":{
                "HEADLINE":"Attention",
                "BTN":{
                    "CANCEL": "Revenir à la question",
                    "CONFIRM": "Quitter la question"
                }
            }
        }
    },
    "BTN": {
        "PAUSE": "Pause",
        "CANDIDATE-PAUSE": "Pause",
        "CARRY-ON": "Continuer",
        "BACK": "Retour",
        "UNLOCK": "Déverrouiller",
        "CORRECT": "Confirmer",
        "QUIT": "Quitter",
        "QUIT-APP": "Quitter l’application",
        "QUIT-EARLY-ASSESSMENT": "Quitter l'examen",
        "QUIT-ASSESSMENT": "Quitter le logiciel",
        "SUBMIT": "Envoyer",
        "CONTINUE": "Continuer",
        "START": "Commencer",
        "ADMIN_MENU": "Menu du surveillant",
        "INVIGILATOR": "Surveillant",
        "ASSISTANCE": "Assistance",
        "INSTRUCTIONS": "Instructions",
        "BOOKMARKS": "Signets",
        "OK": "OK",
        "CANCEL": "Annuler",
        "BACKGROUNDRESOURCE": "Matériel de référence",
        "CLOSE": "Fermer",
        "PRE-RELEASE": "Document de préparation",
        "EXTRA-TIME": "Temps <br>supplémentaire",
        "RECORD-INCIDENT": "Consigner un<br> incident",
        "CONFIRM-PAUSE": "Confirmer",
        "CONFIRM-EXTRA-TIME": "Confirmer",
        "CONFIRM-INCIDENT": "Confirmer la consignation de l’incident",
        "UNLOCK-ASSESSMENT": "Reprendre l’examen",
        "RESUME-ASSESSMENT": "Reprendre l’examen",
        "INVIGILATOR-ACCESS": "Accès au menu du surveillant",
        "RESUME": "Reprendre",
        "RETRY-UPLOAD": "Réessayer de charger le fichier",
        "YES": "Oui",
        "NO": "Non",
        "SAVE": "Enregistrer",
        "CONFIRM": "Confirmer",
        "END-ASSESSMENT": "Mettre fin à l'examen",
        "FINISH-EARLY": "Terminer en avance",
        "GOTO-JOURNAL": "Ouvrir le journal",
        "RESET-TIME": "Réinitialiser la durée",
        "RESTART": "Confirmer la reprise"
    },
    "CONTENT": {
        "COPYRIGHT_TEXT": "© Organisation du Baccalauréat International {{year}}. Tous droits réservés.",
        "SCROLLINFO": "Faites défiler la page vers le bas pour continuer.",
        "PROCESSING": "Traitement en cours",
        "MARK": "point{{totalMarks > 1 && 's' || ''}}"
    },
    "BACKGROUND": {
        "TAB": {
            "READING": "Lecture",
            "VIDEO": "Vidéo"
        }
    },
    "SYSTEM": {
        "CLOCK": {
            "REMAINING": "Temps restant",
            "ELAPSED": "Temps écoulé",
            "NONE": "Masquer l’horloge",
            "HOURS": "heures",
            "HOUR": "heure",
            "MINUTES": "minutes",
            "MINUTE": "minute",
            "SECONDS": "secondes",
            "SECOND": "seconde",
            "PAUSED": " (En pause)"
        },
        "SAVEINDICATOR": {
            "SAVING": "Enregistrement en cours...",
            "SAVED": "Réponses enregistrées"
        },
        "FOCUSLOST": {
            "TITLE": "Activité interrompue",
            "WARNING": "Le système a détecté que l’examen a été interrompu ou que le candidat a essayé de quitter l’examen.",
            "LOGGED": "Cela a été consigné dans le fichier contenant vos réponses.",
            "ALTERNATIVE": {
                "TITLE": "Activité interrompue",
                "WARNING": "La session a été interrompue. Cependant, aucune action supplémentaire n’est nécessaire et vous pouvez continuer votre examen."
            }
        }
    },
    "TOOLTIPS": {
        "BOOKMARKBTN": "Afficher les questions marquées d’un signet",
        "ISBOOKMARKED": "Supprimer le signet associé à cette question",
        "ISNOTBOOKMARKED": "Marquer cette question d’un signet",
        "FLAGASCOMPLETE": "Signaler comme terminée",
        "FLAGASUNCOMPLETE": "Signaler comme incomplète"
    },
    "VIDEOPLAYER": {
        "FULLSCREEN": "Activer/Désactiver le mode plein écran",
        "POSTROLLCLOSE": "Fermer",
        "PLAYPAUSE": "Lecture/Pause",
        "MUTE": "Couper/Réactiver le son",
        "STOP": "Arrêter",
        "SUBTITLE_ON": "Activer les sous-titres",
        "CAPTION": "Sous-titres",
        "CAPTION_NONE": "Aucun"
    },
    "IAA": {
        "iaa": "Aménagements de la procédure d’évaluation",
        "allegedAcademicMisconduct": "Mauvaise conduite présumée",
        "disruptionToExam": "Perturbation de l’examen",
        "pause": "Mise en pause de l’examen par le surveillant",
        "resumeByInv": "Reprise de l’examen activée par le surveillant",
        "resumeByCand": "Reprise de l’examen activée par le candidat",
        "extratime": "Temps supplémentaire octroyé par le surveillant",
        "genericNote": "Note générale / Autre incident",
        "loginSuccess": "Connexion réussie",
        "loginFailed": "Échec de la connexion",
        "invLoginSuccess": "Connexion réussie",
        "invLoginFailed": "Échec de la connexion",
        "assessmentStart": "L’examen a commencé",
        "resume": "Reprise de l’examen",
        "fireAlarm": "Alarme incendie",
        "anyOther": "Toute autre raison",
        "toiletBreak": "La candidat s’est absenté pour aller aux toilettes",
        "candidateCanPause": "Mise sur pause",
        "extraTime": "Temps supplémentaire",
        "colorTheme": "Thème de la couleur",
        "dyslexicFont": "Option de police accessible",
        "zoomLevel": "Niveau de zoom",
        "extraTimeInfo": "Durée totale accordée au candidat : {{ totalTimeAvailable }} ; temps écoulé : {{timeElapsed }} ; temps restant : {{timeLeft}}",
        "videoSubtitleAutoEnable": "Activation des sous-titres pour les vidéos",
        "activated": "{{key}} activé(e)",
        "deactivated": "{{key}} désactivé(e)",
        "changedValue": "Le paramètre du {{key}} a été modifié de {{oldVal}} à {{newVal}}.",
        "changedValueNoPreviousValue": "Le paramètre du {{key}} a été fixé à {{newVal}}.",
        "examinationAdministrationIssue": "Problème de gestion de l’examen",
        "candidateIllness": "Candidat souffrant d’une maladie",
        "candidateIllnessTemporaryMedicalCondition": "Candidat souffrant d’une maladie ou d’un problème médical temporaire ",
        "extremeWeatherCondition": "Conditions météorologiques extrêmes",
        "inclusiveAssessmentArrangements": "Aménagements de la procédure d’évaluation à des fins d’inclusion",
        "misconductDuringExamination": "Mauvaise conduite pendant l’examen",
        "unauthorizedMaterialInExamination": "Matériel non autorisé amené dans la salle d’examen",
        "unethicalPractice": "Pratiques contraires à l’éthique",
        "multipleResponseFiles": "Multiples fichiers de réponses",
        "finishEarlyByCandidate": "Terminer en avance (candidat)",
        "finishEarlyByInvigilator": "Terminer en avance (surveillant)",
        "focusLost": "Application focus lost",
        "focusLostAlternative": "Application focus lost",
        "leavePackageEarlyByInvigilator": "Logiciel quitté par le surveillant",
        "alternativeContent":  "Autre contenu",
        "alternativeContents": {
            "visuallyImpaired": "malvoyant"
        },
        "assessmentReStartHybrid": "Reconnexion en ligne",
        "assessmentReStartDisk": "Reconnexion",
        "responseFileBlank": "Aucune réponse"
    },
    "CONTENTOBJECT": {
        "RESPONSE-SHORT-TEXT": {
            "LABEL": ""
        },
        "TABEL": {
            "NEXT-STEP": "Étape suivante",
            "RESET": "Réinitialiser",
            "ALIGNMENT": "Alignement",
            "STEP1": "Étape 1",
            "STEP2": "Étape 2",
            "STEP3": "Étape 3",
            "ROWS": "Lignes",
            "COLS": "Colonnes",
            "LOCKED": "Verrouillé",
            "TABLE-SIZE": "Taille du tableau",
            "TABLE-DATA": "Données du tableau",
            "HELPTEXT-1": "Veuillez choisir l’alignement de votre tableau : <strong>horizontal</strong> (titres des lignes à gauche) ou <strong>vertical</strong> (titres des colonnes en haut)",
            "HELPTEXT-2": "Veuillez choisir le nombre de lignes et de colonnes de votre tableau (vous pourrez en ajouter ou en supprimer ultérieurement).",
            "HELPTEXT-3": "Veuillez saisir vos données dans le tableau (y compris les titres)",
            "CTX-MENU": {
                "READ-ONLY": "En lecture seule",
                "REMOVE-ROW": "Supprimer la ligne",
                "REMOVE-COL": "Supprimer la colonne",
                "ROW-ABOVE": "Ajouter une ligne au-dessus",
                "ROW-BELOW": "Ajouter une ligne en dessous",
                "COL-LEFT": "Ajouter une colonne à gauche",
                "COL-RIGHT": "Ajouter une colonne à droite",
                "MERGE-CELLS": "Fusionner les cellules",
                "UNMERGE-CELLS": "Annuler la fusion des cellules",
                "FORMAT-AS-HEADER-ROW": "Formatez comme titre d'en-tête",
                "FORMAT-AS-HEADER-COLUMN": "Formatez comme titre de colonne",
                "SET-AS-HEADER-CELL": "Définir comme cellule d’en-tête",
                "UNSET-AS-HEADER-CELL": "Désactiver la cellule d’entête",
            },
            "CREATE-NEW-TABLE-OBJECT": "Créer un nouveau tableau",
            "CREATE-TABLE-SIZE": "Créer un tableau de {{cols}} colonnes et {{rows}} rangées"
        },
        "IAA-CONTAINER": {
            "ADD-NEW-BTN": "Add IAA-Container",
            "FILTER-BTN": "Show: ",
            "FILTER-BTN-PREVIEW": "IAA-Content: ",
            "IAA-CONTAINER": {
                "all": "All",
                "default": "Default",
                "visuallyImpaired": "Visually Impaired"
            },
            "WARNING-MESSAGES":{
                "IS-DEFAULT":"Falling back to the default section for this IAA Container",
                "IAA-CONTAINER-NOT-EXISTS": "'{{s}}' section does not exist!",
                "IAA-OBJECTS-NOT-EXISTS": "No object defined in '{{s}}' section!"
            }
        },
        "CAROUSEL": {
            "LOADING": "Chargement du carrousel en cours..."
        },
        "RESPONSETEXTBOX": {
            "HIGHLIGHT": "Surligner",
            "QUESTION-HIGHLIGHT": "Question highlight",
            "IMAGE-FROM-CALC": "Image de la calculatrice",
            "LAODING":"Chargement ...",
            "LOADING-FAILED":"Richtext ne peut pas être chargé. S'il vous plaît appelez le surveillant.",
            "ERRORS":{
                "UNLOADED":{
                    "HEADLINE":"Une erreur est survenue",
                    "MESSAGE":"Richtext ne peut pas être chargé.<br> S'il vous plaît appelez le surveillant.<br><strong>{{errorMessage}}</strong>"
                }
            }
        },
        "TAB": {
            "LOADING": "Chargement des onglets en cours..."
        },
        "IFRAME": {
            "CONTENT": [
                "<p><strong>Champ iFrame</strong><br />Le contenu du champ iFrame a été sélectionné et s’affichera en mode Aperçu uniquement.<br />Les dimensions choisies pour le champ sont néanmoins indiquées dans cette case.</p>",
                "<p><strong>Champ iFrame</strong><br />Le contenu du champ iFrame n’a pas encore été sélectionné.<br />Veuillez utiliser le bouton « Parcourir la bibliothèque multimédia » pour sélectionner le contenu du champ iFrame (qui doit déjà avoir été chargé sur l’ordinateur).</p>"
            ]
        },
        "HINT": {
            "TITLE": "Indice",
            "EXPLANATION": "Cet indice affichera des informations utiles si vous décidez de l’ouvrir. <br/><strong>Si vous l’ouvrez, {{marks}} points seront déduits pour cette question.</strong>",
            "EXPLANATION2":"Êtes-vous sûr(e) de vouloir ouvrir cet indice ? <br/><strong>{{marks}} points seront déduits pour cette question.</strong>",
            "CONFIRM1": "Je comprends",
            "CANCEL1": "Annuler",
            "CONFIRM2": "Ouvrir l’indice",
            "CANCEL2": "Annuler",
            "TAKEN": "INDICE OUVERT – Le nombre de points suivant a été déduit : {{marks}}",
            "TAKEN-PDF": "INDICE DE NIVEAU {{level}} OUVERT – Veuillez déduire {{marks}} point(s).",
            "TOTAL-TAKEN-PDF": "INDICE DE NIVEAU {{levels}} OUVERT – Veuillez déduire {{marks}} point(s)."
        },
        "SCATTERGRAPH": {
            "GRAPH-SETTINGS": "Paramètres du graphique",
            "OPEN-GRAPH-SETTINGS": "Ouvrir les paramètres du graphique",
            "GRAPH-TITLE": "Titre du graphique",
            "X-LABEL": "Légende de l’axe des abscisses",
            "Y-LABEL": "Légende de l’axe des ordonnées",
            "X-DECIMALS": "Nombre de décimales affichées (axe des abscisses)",
            "Y-DECIMALS": "Nombre de décimales affichées (axe des ordonnées)",
            "X-MINIMUM": "Axe des abscisses – Valeur minimale ",
            "Y-MINIMUM": "Axe des ordonnées – Valeur minimale ",
            "X-INCREMENT": "Axe des abscisses – Graduation/Échelle",
            "Y-INCREMENT": "Axe des ordonnées – Graduation/Échelle",
            "CLOSE": "Fermer",
            "SAVE-CHANGES": "Appliquer les changements",
            "LINE-TOOL": "Dessiner une ligne",
            "RECTANGLE-TOOL": "Placer un point bleu",
            "CIRCLE-TOOL": "Placer un point blanc",
            "DIAMOND-TOOL": "Placer un point rouge",
            "TRIANGLE-TOOL": "Placer un point vert",
            "POLYGON-TOOL": "Placer un point jaune",
            "LABEL-OUTLIER": "Identifier une valeur aberrante",
            "LABEL-REGION": "Identifier une région",
            "INSTRUCTIONS-LABEL": "Instructions",
            "INSTRUCTIONS-TEXT": "Cliquez sur « COMMENCER » pour commencer à placer les points sur votre graphique.",
            "INSTRUCTIONS-BUTTON": "COMMENCER",
            "X-DEFAULT-LABEL": "Légende de l’axe des abscisses",
            "Y-DEFAULT-LABEL": "Légende de l'axe des ordonnées",
            "DEFAULT-TITLE": "Titre",
            "REGION": "région",
            "OUTLIER": "valeur aberrante"
        }
    },
    "PREFIX": {
        "QUESTION": "Question",
        "QUESTION-PART": "Question",
        "PRE-RELEASE": "Document de préparation",
        "JOURNAL": "Journal"
    },
    "AUTOPLOT": {
        "OPENWIZARD": "Ouvrir l’assistant graphique",
        "SCATTER": "Graphique en nuage de points",
        "BAR": "Diagramme à barres",
        "PIE": "Diagramme circulaire",
        "SELECTIONMODE-INFOTEXT": {
            "FULL": "Cliquer sur le titre d’une colonne ou d’une ligne pour sélectionner {{axis}} dans {{series}}.",
            "FIELDS": "Cliquer en maintenant le bouton enfoncé pour sélectionner les données pour {{axis}}.",
            "FIELDS_SERIES": "Cliquer en maintenant le bouton enfoncé pour sélectionner les données pour {{axis}} dans {{series}}."
        },
        "CHARTSETTINGS": {
            "TITLE": "Titre du graphique",
            "TITLE-PLACEHOLDER": "Saisir le titre du graphique ici",
            "LABELS": "Légendes",
            "SELECT-LABELS": "Sélectionner les légendes",
            "LABELS-PLACEHOLDER": "Veuillez sélectionner les légendes",
            "VALUES": "Valeurs",
            "VALUES-PLACEHOLDER": "Veuillez sélectionner les valeurs",
            "X-LABEL": "Légende pour les abscisses",
            "X-LABEL-PLACEHOLDER": "Saisir la légende pour les abscisses ici",
            "X-VALUES": "Valeurs pour les abscisses",
            "X-VALUES-PLACEHOLDER": "Veuillez sélectionner les valeurs",
            "Y-LABEL": "Légende pour les ordonnées",
            "Y-LABEL-PLACEHOLDER": "Saisir la légende pour les ordonnées ici",
            "Y-VALUES": "Valeurs pour les ordonnées",
            "Y-VALUES-PLACEHOLDER": "Veuillez sélectionner les valeurs",
            "RESET-VALUES": "Réinitialiser les valeurs",
            "SELECT-VALUES": "Sélectionner les valeurs",
            "SERIES-NAME": "Nom de la série",
            "SERIES-NAME-PLACEHOLDER": "Saisir le nom de la série ici",
            "NEW-SERIES-BTN": "Ajouter une série",
            "REMOVE-SERIES-HOVER": "Supprimer l’ensemble de la ou des séries"
        },
        "LOBF": {
            "HIDE": "Masquer la droite de régression",
            "SHOW": "Afficher la droite de régression",
            "DRAW": "Tracer la droite de régression"
        }
    },
    "REPORTS": {
        "DIALOGS": {
            "TYPE": {
                "WARNING": "Warning",
                "INFO": "Information",
                "CONFIRM": "Please confirm"
            },
            "ERRORS": {
                "NO-EXPORT-DATA": "There is no data to be exported"
            }
        },
        "TABS": {
            "ANOMALIES": "By Anomaly",
            "CORRUPTED-FILES": "By Corrupted Files"
        },
        "TOOLTIPS": {
            "BUTTONS": {
                "EXPORT-BTN": "Export as Excel Sheet",
                "REFRESH-BTN": "Refresh view"
            }
        },
        "ANOMALIES": {
            "LIST": {
                "TITLE": "Response File Anomaly Report",
                "SEARCH": "Search:",
                "FILTER": "Filters:",
                "SESSION": "Session:",
                "LEGEND": {
                    "ALREADY-SUBMITTED": "Additional file received after submission",
                    "RESPONSEFILE-IN-ABSENCE": "File received after flagged absent",
                    "BEFORE-TIMEFRAME": "Early submission",
                    "AFTER-TIMEFRAME": "Late submission",
                    "FOCUS-LOST": "Focus Lost",
                },
                "GRID": {
                    "REASON": "Flag",
                    "PAPER-CODE": "Paper Code",
                    "PAPER-NAME": "Paper Name",
                    "CANDIDATE-NAME": "Candidate",
                    "CANDIDATE-LASTNAME": "Candidate last name",
                    "CANDIDATE-FIRSTNAME": "Candidate first name",
                    "CANDIDATE-NUMBER": "Candidate Number",
                    "SCHOOL-CODE": "School Code",
                    "RESPONSE-FILE": "Response Filename",
                    "ACTIONS": {
                        "OPEN-REPORT": "Open"
                    }
                },
                "TOOLTIP": {
                    "SCHOOL-NAME": "School:",
                    "ASSESSMENT-TIMEFRAME": "Assessment's time frame:",
                    "RESPONSE-TIME": "Additional submission:",
                    "SUBJECT": "Subject:",
                    "SUBMITTED-ON": "First Submission:"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        },
        "CORRUPTED-FILES": {
            "LIST": {
                "TITLE": "Corrupted Response Files Report",
                "SEARCH": "Search:",
                "LEGEND": {
                    "VIRUS": "Virus",
                    "CORRUPTED-ZIP": "Corrupted Zip file",
                    "ZEROBYTE": "File with Zerobytes",
                    "UNIDENTIFIED-CASE": "Unidentified case"
                },
                "GRID": {
                    "RESPONSE-FILE": "Filename",
                    "DATE-TIME": "Date/Time Received",
                    "RESULT": "Result"
                },
                "RESULTS": {
                    "VIRUS": "Virus",
                    "CORRUPT-ZIP": "Corrupted Zip File",
                    "ZEROBYTE": "Zero bytes"
                },
                "REMOVE-FILTERS-BTN": "Remove all filters"
            }
        }
    },
    "ADMIN-UI": {
        "ASSESSMENT": {
            "TOOLTIPS":{
                "REMOVE-FILTERS-BTN": "Supprimer les filtres",
                "REMOVE-FILTER-BTN": "Supprimer le filtre",
                "EXPORT-BTN": "Exportation",
                "REFRESH-BTN": "Rafraîchir"
            },
            "LIST": {
                "SHOW-STATISTICS": "Afficher les statistiques",
                "TITLE": "Système d’administration – Liste de codes pour l’examen",
                "TITLE-ASSESSMENT": "Assessment List",
                "TITLE-SCHOOL": "Liste de l’établissement",
                "GRID": {
                    "TITLE": "Titre",
                    "SUBJECT": "Matière",
                    "PAPER-CODE": "Code de l’épreuve",
                    "SESSION": "Session",
                    "LANGUAGE": "Langue",
                    "SCHOOL-NAME": "Nom de l’établissement",
                    "SCHOOL-CODE": "Code de l’établissement",
                    "PROGRAMME": "Programme",
                    "CANDIDATES-REGISTERED": "Candidats (inscrits)",
                    "RESPONSES-RECEIVED": "Fichiers de réponses reçus",
                    "RESPONSES-OUTSTANDING": "Réponses en attente",
                    "SUBMISSIONS": "Envois",
                    "SUBMISSIONS-OUTSTANDING": "Envois en attente",
                    "SUBMISSIONS-ABSENT": "Nombre total de candidats absents",
                    "TOTAL-SCHOOLS": "Total Schools",
                    "TOTAL-FILES-UNMATCHED": "Total Response Files Unmatched",
                    "TOTAL-INCIDENTS": "Total Incidents",
                    "ACTIONS": {
                        "OPEN-SCHOOL-LIST": "Ouvrir la liste de l’établissement",
                        "OPEN-ASSESSMENT-DETAIL": "Afficher les renseignements"
                    }
                },
                "SELECT-DEFAULT": {
                    "SUBJECT": "Sélectionner la matière",
                    "LANGUAGE": "Sélectionner la langue",
                    "SESSION": "Sélectionner la session"
                },
                "FILTER": "Filtrer",
                "FILTERS": {
                    "NO-RESPONSE-FILE": "Aucun fichier de réponses n’a été chargé",
                    "ALL-RESPONSE-FILE": "Tous les fichiers de réponses ont été chargés",
                    "MISSING-RESPONSE-FILE": "Fichiers de réponses manquants",
                    "NO-DOWNLOADS": "Aucun téléchargement pour le moment",
                    "NO-SUBMISSIONS": "Aucun envoi pour le moment",
                    "ALL-SUBMISSIONS": "Tous les envois sont terminés",
                    "MISSING-SUBMISSIONS": "Envois manquants"
                },
                "SEARCH": "Rechercher",
                "PLACEHOLDER": {
                    "SCHOOL-NAME": "Nom de l’établissement",
                    "SCHOOL-CODE": "Code de l’établissement"
                },
                "SELECTED-FILTER":"Selected Filters",
                "FILTER-TEXT": {
                    "statistics":          "Statistics",
                    "search":              "Search <strong>\"{{s}}\"</strong>",
                    "subject":             "Subject <strong>\"{{s}}\"</strong>",
                    "language":            "Language <strong>\"{{s}}\"</strong>",
                    "session":             "Session <strong>\"{{s}}\"</strong>",
                    "school_code":         "School-Code <strong>\"{{s}}\"</strong>",
                    "school_name":         "School-Name <strong>\"{{s}}\"</strong>",
                    "no_downloads":        "No downloads yet",
                    "no_responses":        "No response files uploaded",
                    "all_responses":       "All response files uploaded",
                    "missing_responses":   "Missing response files",
                    "no_submissions":      "No submissions yet",
                    "all_submissions":     "All submissions complete",
                    "missing_submissions": "Missing submissions"
                }
            },
            "DETAIL": {
                "TITLE": "Examen",
                "SEARCH": "Rechercher des candidats",
                "SUBMISSIONS-COMPLETE": "Tous les envois sont terminés pour cet examen.",
                "PIRATE-FILES-INFO": "<span class=\"label label-danger\"><strong>{{ pirate_response_files_count }}</strong> fichiers de réponses</span> reçus n'ont pas pu être automatiquement mis en correspondance avec des candidats inscrits.<br><br>Veuillez effectuer cette action manuellement.",
                "UPLOAD-DONE": "Chargement terminé.",
                "UPLOAD-CONFIRM-MESSAGE-DONE": "Les fichiers de réponses ont été chargés avec succès.<br><br>Veuillez noter que le traitement des fichiers de réponses peut prendre une à trois heures.",
                "UPLOAD-CONFIRM-MESSAGE-ERROR": "Un problème est survenu. Certains fichiers n'ont pas été chargés : <br>",
                "FILTERS": {
                    "MISSING-RESPONSE": "Fichier de réponses manquant",
                    "INCIDENTS-LOGGED": "Contenant des incidents",
                    "IGNORE-SUBMITTED": "Masquer les candidats dont les fichiers de réponses ont été envoyés"
                },
                "CANDIDATE-LIST": {
                    "TITLE": "Candidats",
                    "INFO-PANELS": {
                        "NO-RESPONSE": "Aucun fichier de réponses reçu.",
                        "RESPONSE-RECEIVED": "Fichier de réponse reçu le {{ received_on }}",
                        "ONE-OPEN-INCIDENT": "Il y a 1 incident ouvert",
                        "MULTIPLE-OPEN-INCIDENTS": "Il y a {{ count }} incidents ouverts",
                        "SUBMITTED_ON": "Envoyé à l’IB",
                        "RESPONSE-FILES-RECEIVED": "{{count}} Fichier de réponses reçu et en cours de traitement",
                        "RESPONSE-FILES-SUCCESS": "{{count}} Fichier de réponses traité avec succès et prêt à être envoyé",
                        "DUPLICATE-RESPONSE-FILES": "{{count}} duplicate response files received",
                        "FILE-NAME": "Nom du fichier",
                        "RESPONSE-BLANK": "Ce fichier de réponses ne contient aucune réponse du candidat."
                    },
                    "TOOLTIP":{
                        "DUPLICATE-RECEIVED-FILE":"Fichier de réponses reçu en double"
                    },
                    "CAPTURED-INCIDENTS": {
                        "TITLE": "Incidents enregistrés",
                        "INCIDENT": "Incident",
                        "TIME": "Heure",
                        "NOTE": "Note",
                        "ADD-NOTE": "Ajouter une note"
                    },
                    "CAPTURE-NEW-INCIDENT": "Consigner un nouvel incident",
                    "SUBMIT-TO-IB": "Envoyer à l’IB",
                    "SUBMITTED-TO-IB": "Envoyé à l’IB",
                    "UNSUBMIT-CANDIDATE": "Unsubmit candidate",
                    "ATTENDANCE_PREFIX": "Présence",
                    "CHECK-HYBRID-RESPONSE-BTN": "Récupération de la réponse en ligne"
                },
                "ACTIONS": {
                    "SELECT-ALL": "Sélectionner tout",
                    "SUBMIT-SELECTED": "Envoyer les éléments sélectionnés",
                    "ADD-GLOBAL-NOTE": "Appliquer une note globale",
                    "ADD-NEW-GLOBAL-INCIDENT": "Créer un incident global"
                },
                "STATISTICS": {
                    "CANDIDATES-REGISTERED": "Candidats inscrits : {{ count }}",
                    "CANDIDATES-WITH-RESPONSES": "Candidats avec fichier de réponses : {{ count }}",
                    "POTENTIAL-PIRATES": "Candidats non inscrits à l'avance : {{ count }}",
                    "DROP-FILES": "Déposer les fichiers de réponses ici.",
                    "UPLOAD-FILES": "Charger {{ count }} fichier(s)",
                    "UNMACHTED-RESPONSES": "Associer les fichiers de réponses manuellement",
                    "FILE-REJECTED": "1 fichier a été rejeté.",
                    "FILES-REJECTED": "{{ count }} fichiers ont été rejetés.",
                    "CANDIDATES-ABSENT": "Candidats déclarés absents : {{ count }}"
                },
                "CHART": {
                    "NOT-SUBMITTED": "En attente d’envoi",
                    "SUBMITTED": "Envoyés",
                    "SUBMITTED-TITLE": "Fichiers de réponses envoyés",
                    "CANDIDATES-ABSENT": "Candidats absents",
                    "RESPONSE-RECEIVED-TITLE": "Fichiers de réponses reçus",
                    "RESPONSE-RECEIVED": "Reçus",
                    "RESPONSE-MISSING": "En attente"
                },
                "ORDERBY": {
                    "PREFIX": "Classer par",
                    "FIRST-NAME": "prénom",
                    "LAST-NAME": "nom",
                    "CANDIDATE-CODE": "code du candidat"
                },
                "DIALOG": {
                    "INCIDENT": {
                        "HEADER": "Informations sur l’incident",
                        "TITLE": "Incidents consignés <span class=\"small\">pour</span>",
                        "TITLE-GLOBAL-INCIDENT": "Note globale",
                        "TITLE-NEW-GLOBAL-INCIDENT": "Incident global",
                        "PANEL-TITLE": "Candidats",
                        "INCIDENT-EXPLAINS-OTHER": "Cet incident explique d’autres incidents consignés concernant le candidat",
                        "CANDIDATE-NAME": "Nom du candidat",
                        "CANDIDATE-DATE-OF-BITH": "Date de naissance",
                        "CANDIDATE-CODE": "Code du candidat",
                        "CAPTURED-INCIDENT": "Appliquer une note concernant l’incident",
                        "INCIDENT-TYPE": "Type d’incident",
                        "INCIDENT-TYPE-PLACEHOLDER": "-- Sélectionner le type d’incident --",
                        "INCIDENT-REASON-PLACEHOLDER": "-- Sélectionner la raison --",
                        "DESCRIPTION": "Description",
                        "EXPLANATORY-NOTE-CAPTURED": "Note explicative consignée ?",
                        "EXPLANATORY-NOTE-PLACEHOLDER": "Veuillez saisir une note explicative.",
                        "EXPLAINED-BY": "Expliqué par l’incident indiqué ci-dessus",
                        "ATTACH-GLOBAL-NOTE": "Appliquer une note globale",
                        "INCIDENTS-NOT-EXISTS": "Aucun incident ouvert ne nécessite l'ajout d'une note explicative. Vous ne pouvez pas ajouter de note globale.",
                        "CANCEL": "Annuler",
                        "SAVE": "Enregistrer",
                        "SELECT-ALL":"Sélectionner tout",
                        "DESELECT-ALL":"Sélectionner tout",
                        "ERROR-DIALOG-HEADLINE":"Nous sommes désolés!",
                        "ERROR-DIALOG-MESSAGE":"Un problème technique vous empêche de sauvegarder cette note.<b>Nous essayons de résoudre ce problème et vous prions de nous excuser pour la gêne occasionnée.<br>Nous vous enverrons un courriel avec plus d’informations dès que possible."
                    },
                    "MATCHED-RESPONSE-FILES": {
                        "SUCCESS": "La correspondance a été correctement établie."
                    },
                    "UNMATCHED-RESPONSE-FILES": {
                        "TITLE": "Fichiers de réponses sans correspondance",
                        "SEARCH": "Rechercher",
                        "CONTENT": "Nous avons détecté <span class=\"badge\">{{ pirate_response_files_count }}</span> fichiers de réponses sans correspondance. <br><br>Veuillez sélectionner un fichier de réponses sur la gauche et le faire correspondre à un candidat dans la partie droite de l'écran.",
                        "CANDIDATE-NUMBER": "Code du candidat",
                        "MISSING-RESPONSE": "Fichiers de réponses manquants",
                        "UNMATCHED": "Fichiers de réponses sans correspondance",
                        "MATCH-TO": "Associer",
                        "SELECT-CANDIDATE": "Associer au candidat",
                        "INFO": "Veuillez sélectionner un fichier de réponses à faire correspondre.",
                        "CLOSE": "Fermer",
                        "CONFIRM": "Confirmer",
                        "CONFIRM-TITLE": "Confirmer",
                        "CONFIRM-MESSAGE": "Êtes-vous sûr(e) de vouloir établir une correspondance entre les fichiers suivants ? <br><br>Fichier de réponses : <strong>{{ response_file }}</strong> <br><br>et <br><br>Candidat inscrit : <strong>{{ candidate }}</strong>",
                        "UNMATCHED-CONFIRM-BTN": "Supprimer la correspondance entre un fichier de réponses et un candidat non inscrit à l’avance",
                        "UNMATCHED-CONFIRM-MESSAGE": "Êtes-vous sûr(e) de vouloir supprimer<br><br>le fichier de réponses <strong>{{ response_file }}</strong> <br><br>associé au<br><br>candidat inscrit <strong>{{ candidate }}</strong> ?<br><br>Si vous le supprimez, ce fichier de réponses sera à nouveau disponible en tant que \"fichier de réponses sans correspondance\"."
                    },
                    "HYBRID-RESPONSE-FILES":{
                        "TITLE": "Restaurer la réponse en ligne",
                        "TABLE":{
                            "HEADER":{
                                "SESSION-ID": "Numéro d'identification de la session",
                                "SESSION-LIFETIME": "Durée de la session",
                                "TIME-ELAPSED":"Temps écoulé"
                            }
                        },
                        "SESSION-LIFETIME-UNKNOWN": "Inconnue",
                        "CANCEL":"Annuler",
                        "RESTORE":"Restaurer",
                        "SELECT":"Sélectionner",
                        "HAS_BEEN_RESTORED": " a été restauré et sera bientôt traité.",
                        "NO-SESSIONS-FOUND": "Aucune réponse n'a été trouvée en ligne.",
                        "CLOSE":"Fermer",
                        "IS-RESTORED":"a été restauré"
                    },
                    "SUBMIT-WITH-ONLY-BLANK-RESPONSES":{
                        "HEADER": "Avertissement",
                        "MESSAGE": "Tous les fichiers de réponses reçus pour ce candidat sont vides. <br/> Envoyez les fichiers si vous pensez que le candidat n’a pas répondu pendant l’examen. <br/>Si vous pensez qu’il y a un problème, veuillez contacter l’IB.",
                        "BTN-SUBMIT": "Envoyer les fichiers vides",
                        "BTN-CANCEL": "Annuler"
                    },
                    "SUBMIT-SELECTED-WITH-BLANK-RESPONSES":{
                        "HEADER": "Warning",
                        "MESSAGE": "{{count_successfully}} files submitted successfully, {{count_blank}} files not submitted as they were found to be blank. Please submit these individually if necessary.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    },
                    "SUBMIT-WITH-ATTENDANCE-ABSENT":{
                        "HEADER": "Warning",
                        "MESSAGE": "This candidate has a response file, but is also flagged as absent and therefore did not sit the assessment.<br/>Please change their attendance status and resubmit, or contact the IB for further assistance if that is not suitable.",
                        "BTN-SUBMIT": "Ok",
                        "BTN-CANCEL": "Cancel"
                    }
                }
            }
        },
        "AUTH": {
            "REGISTRATION": "Inscription",
            "SAVE": "Enregistrer",
            "LOGIN-FAILED": "Identifiants de connexion non valides"
        },
        "PROGRESS": {
            "LOGGED_IN": "Login réussi",
            "SCHOOL_DATA": "Reading school data"
        },
        "MODEL": {
            "CANDIDATEATTENDANCE": {
                "ABSENT": "absent",
                "ATTENDED": "présent",
                "UNKNOWN": "inconnue"
            },
            "CANDIDATEREGISTRATION": {
                "FULLNAME": "{{ first_name}} {{ last_name }}",
                "TOSTRING": "{{ fullname }}, {{ date }}, {{ number }}"
            }
        },
        "LOGIN": {
            "HEADLINE": "Console d’administration",
            "LABELS"  : {
                "LANGUAGE"         : "Sélectionner la langue",
                "INVIGILATOR-CODE" : "Code du surveillant",
                "ADMIN-ACCESS-CODE": "Code de la console d'administration"
            },
            "CONTENT"    : {
                "LOGGED-HEADLINE" : "Connecté(e)",
                "NOT-LOGGED": "Vous n'êtes actuellement pas connecté(e).",
                "LOGGED": "Voici l'écran d'accueil. Vous pouvez utiliser le menu en haut à gauche de l'écran pour vous déplacer."
            },
            "LOGIN-BTN": "Connexion"
        },
        "COMPCHECK": {
            "LIST-POPOVER-TITLE": "Compatibility Check Results ({{count}})",
            "LIST-POPOVER":       "Failed:{{results.failed}}, Warning:{{results.warning}}, Passed:{{results.passed}}",
            "LIST":               {
                "TITLE": "Compatibility Check Results",
                "GRID": {
                    "COMPUTER-NAME":           "Computer-Name",
                    "TSTAMP":                  "Created",
                    "TOTAL-COMPCHECKRESPONSE": "# Responses",
                    "TOTAL-COMPCHECKRESULTS":  "# Test Results",
                    "RESULT":                  "Result",
                    "RESULT-FAILED":           "# Failed",
                    "RESULT-WARNING":          "# Warning",
                    "RESULT-PASSED":           "# Passed",
                    "TIME":                    "Time Taken",
                    "NAME":                    "User-Name",
                    "EMAIL":                   "E-Mail"
                }
            },
            "FILTER":             {
                "RESULT-LABEL":   "Filter",
                "SEARCH-LABEL":   "Search",
                "DEFAULT-FILTER": "All"
            },
            "RESULT-DETAILS":     {
                "HEADLINE":                 "Results Details",
                "PANEL-TITLE":              {
                    "PASSED":  "Passed",
                    "FAILED":  "Failed",
                    "WARNING": "Warning"
                },
                "TAB-HEADLINE":             {
                    "USER-INPUT": "User Input",
                    "SELF-TEST":  "Self Test",
                    "USER-TEST":  "User Test"
                },
                "TIME":                     "Time:",
                "TIME-VALUE":               "{{time}}s",
                "FAIL-MESSAGE":             "Fail-Message:",
                "UNEXPECTED-ERROR-MESSAGE": "Unexpected Error Message:",
                "DATA":                     "Data",
                "LANGUAGE-DATA":            "Language-Data"

            },
            "RESULT-STATUS":      {
                "PASSED":  "Passed",
                "FAILED":  "Failed",
                "WARNING": "Warning"
            },
            "ERROR":              {
                "REQUEST": {
                    "TITLE":   "Request Error",
                    "MESSAGE": "Server Message: {{error}}"
                }
            }
        }
    },
    "COLOR-THEME": {
        "DEFAULT": "Défaut",
        "LIGHT-YELLOW": "Jaune clair",
        "BLUE": "Bleu",
        "YELLOW": "Jaune",
        "PINK": "Rose",
        "GREY": "Gris",
        "OFF-WHITE": "Blanc cassé",
        "BLACK": "Noir"
    },
    "COMCHECK": {
        "INFO": {
            "REQUIRED-INFO": "Le champ marqué d’un astérisque doit être rempli."
        },
        "AUDIO-COMP-CHECK": {
          "DESCRIPTION": [
            "L'enregistrement audio ci-dessous devrait démarrer automatiquement. Vérifiez si vous pouvez l'entendre et si le volume est correctement réglé.",
            "Veuillez cliquer sur <strong>Succès</strong> ou <strong>Échec</strong>. Vous passerez ensuite automatiquement à l’étape {{nextStep}}."
          ],
          "FAILED-BTN": "Échec",
          "FAILED-MSG": "Vous avez indiqué que le fichier audio ne s'est pas lancé correctement.",
          "LABEL": "Test audio",
          "SUCCESS-BTN": "Succès"
        },
        "BTN": {
          "CANCEL": "Annuler",
          "CLOSE": "Fermer",
          "CONTINUE": "Passer à l'étape {{nextStep}}",
          "QUIT": "Quitter",
          "REMOVE": "Supprimer",
          "RETRY": "Réessayer de charger le fichier"
        },
        "KEYBOARD-LAYOUT-COMP-CHECK": {
          "KEYBOARD": "Clavier",
          "ACTIVATE-CHECKER": "",
          "ACTIVATE-CHECKER-BTN": "Oui",
          "ACTIVATE-CHECKER-LANG": {
            "ARABIC": "Arabe",
            "KOREAN": "Coréen",
            "MANDARIN_CN": "Chinois caractères simplifiés",
            "MANDARIN_TW": "Chinois caractères traditionnels"
          },
          "ADD-LANG-BTN": " Ajouter une langue",
          "CKEDITOR": {
            "PLACEHOLDER": "Veuillez saisir quelques mots en {{lang}}"
          },
          "CONTINUE-TEST-BTN": "Passer à l’étape suivante",
          "DEACTIVATE-CHECKER-BTN": "Non",
          "DESCRIPTION_1": [
            "Cet appareil sera-t-il utilisé pour un ou plusieurs des examens de langue et littérature ci-dessous ?"
          ],
          "DESCRIPTION_2": [
            "Veuillez indiquer le ou les examens de langue et littérature pour lesquels cet appareil sera utilisé puis cliquez sur <strong>Passer à l’étape suivante</strong>."
          ],
          "DESCRIPTION_3": [
            "Cette étape permet de tester la disposition de votre clavier ainsi que la méthode d’entrée que vous avez choisie, afin de vérifier qu’elles fonctionnent correctement.",
            "Veuillez saisir quelques mots dans les cases pertinentes ci-dessous.",
            "Ce test doit être réalisé pour toutes les langues pour lesquelles cet appareil sera utilisé."
          ],
          "FAILED-BTN": "Échec",
          "FAILED-MSG": "<p>Vous avez indiqué que la vérification de la disposition du clavier ou/et de la méthode d’entrée a échoué pour cette langue.</p><p>Veuillez vérifier que les logiciels nécessaires au bon fonctionnement du clavier et/ou de la police sont installés sur l’appareil. Le cas échéant, contactez l’IB pour obtenir de l’aide.</p>",
          "INSTRUCTION": {
            "CHANGE-KEYBOARD-LAYOUT": "Cliquez sur cette icône pour modifier la disposition du clavier et la méthode d’entrée. Vous devez sélectionner la disposition et la méthode d’entrée qui conviennent pour la langue faisant actuellement l’objet du test.",
            "SELECT-LANG": "",
            "TESTING-SELECTED-LANG": [
              "Veuillez indiquer le résultat de chaque vérification à l’aide des boutons pertinents. Vous devez sélectionner <strong>\"Échec\"</strong> comme résultat du test si le texte que vous avez saisi dans la case ne s’affiche pas normalement.",
              "Une fois ce test terminé, vous pourrez passer à l’étape {{nextStep}}."
            ]
          },
          "LABEL": "Disposition du clavier",
          "MODAL": {
            "HEADER": "Erreur",
            "INFO": "Vous devez indiquer manuellement si le test concernant la disposition du clavier a réussi ou échoué pour toutes les langues. Pour le moment, aucun résultat n’a été saisi pour les langues suivantes :",
            "RESULT-ERROR": "{{langName}}"
          },
          "NO-LANGUAGES": "Aucune langue sélectionnée",
          "SUCCESS-BTN": "Succès"
        },
        "LABEL": "Compatibility Checker – Vérification de la compatibilité des examens sur ordinateur",
        "LANGUAGE-SELECTION": {
          "LABEL": "Sélectionner la langue",
          "LANGUAGE": {
            "ENGLISH_US": "English",
            "FRENCH_FR": "Français",
            "SPANISH_ES": "Español"
          },
          "LANGUAGE-PLACEHOLDER": "Please select your language / Veuillez sélectionner votre langue / Seleccione el idioma"
        },
        "QUIT-MODAL": {
          "HEADER": "Quitter",
          "INFO": [
            "Êtes-vous sûr(e) de vouloir quitter Compatibility Checker ?",
            "Cliquez sur <strong>Annuler</strong> pour revenir en arrière.",
            "Préparation des résultats",
            "Préparer les réponses."
          ]
        },
        "STEP": "Étape {{currentStep}} sur {{maxSteps}}",
        "SUMMARY-COMP-CHECK": {
          "LABEL": "Récapitulatif des résultats",
          "PANEL-HEADER": {
            "ABORTED-TESTS": "Tests abandonnés",
            "FAILED": "Échec",
            "PASSED": "Succès",
            "WARNING": "Avertissement"
          },
          "STATUS-PANEL-DESCRIPTION": {
            "FAILED": [
              "Cet appareil ne dispose pas de la configuration minimale requise pour au moins une catégorie, ou un problème est survenu lors de la lecture d'un fichier multimédia. Il ne peut donc pas être utilisé dans son état actuel pour effectuer les examens sur ordinateur. Veuillez contacter l'IB pour discuter des problèmes soulevés lors de la vérification de la compatibilité.",
              "Veuillez vous assurer que ces vérifications sont effectuées sur tous les appareils qui seront utilisés pour les examens sur ordinateur."
            ],
            "PASSED": [
              "Cet appareil dispose de la configuration recommandée pour une expérience optimale, ou l'excède.",
              "Veuillez vous assurer que ces vérifications sont effectuées sur tous les appareils qui seront utilisés pour les examens sur ordinateur."
            ],
            "WARNING": [
              "Cet appareil dispose de la configuration minimale requise, ou l'excède. Cependant, au moins une des exigences recommandées n'a pas été satisfaite. Cet appareil sera en mesure d'effectuer les examens sur ordinateur, mais les utilisateurs ne bénéficieront probablement pas d'une expérience optimale.",
              "Veuillez vous assurer que ces vérifications sont effectuées sur tous les appareils qui seront utilisés pour les examens sur ordinateur."
            ]
          },
          "STATUS-PANEL-HEADER": {
            "FAILED": "Échec de la vérification de la compatibilité",
            "PASSED": "Succès de la vérification de la compatibilité",
            "WARNING": "Succès de la vérification de la compatibilité avec des avertissements"
          }
        },
        "SYSTEM-COMP-CHECK": {
          "COUNT": "{{currentTestNum}} sur {{testCount}}",
          "LABEL": "Vérification du système",
          "STATUS": {
            "FAILED": "Échec",
            "PASSED": "Succès",
            "PROCESSING": "Traitement en cours...",
            "WARNING": "Avertissement"
          },
          "STATUS-COUNT": {
            "FAILED": "Échecs : {{count}}",
            "PASSED": "Succès : {{count}}",
            "WARNING": "Avertissements : {{count}}"
          },
          "STATUS-MESSAGE": {
            "FAILED": "Cet appareil ne dispose pas de la configuration minimale requise pour cette vérification. Il ne peut donc pas être utilisé pour effectuer les examens sur ordinateur, car l'expérience de l'utilisateur en serait affectée de manière significative.",
            "PASSED": "Cet appareil dispose de la configuration recommandée ou l'excède pour cette vérification.",
            "PROCESSING": "Traitement en cours...",
            "WARNING": "Cet appareil ne dispose pas de la configuration recommandée, mais possède la configuration minimale requise pour cette vérification. Il peut donc être utilisé pour effectuer les examens sur ordinateur, mais l'expérience de l'utilisateur final ne sera pas optimale."
          },
          "TEST-NAME": {
            "DiskSpace": "Vérification de l'espace disque",
            "InternetConnection": "Connexion Internet",
            "MediaServerTest": "Test du serveur média",
            "OSVersion": "Version du système d’exploitation",
            "ScreenRes": "Vérification de la résolution de l’écran",
            "SysMem": "Vérification de la mémoire système",
            "Video": "Vidéo",
            "VmDetection": "Test d’une machine virtuelle",
            "WriteResponse": "Vérification de la sauvegarde locale des fichiers de réponses"
          }
        },
        "UPLOAD-STATUS": {
          "MSG": {
            "PACK-RESPONSE-FAILED": "Pack Response Failed",
            "PACK-RESPONSE-SUCCESS": "Pack Response success",
            "RESPONSE_INITIALIZED": "Response Initialized",
            "RESPONSE_INIT_FAILED": "Response Init failed",
            "UPLOAD-CONFIG-MISSING": "Upload Config missing",
            "UPLOAD-INTERNET-CONNECTION": "Échec de la connexion Internet",
            "UPLOAD-SUCCESS": "Ces résultats ont été envoyés à l’IB.",
            "USER-DATA-EMPTY": "User data is empty",
            "RESPONSE-READY": "Traitement terminé. Vous pouvez désormais <strong>Quitter</strong>."
          },
          "TYPE": {
            "INIT": "Initialisation du chargement des résultats",
            "PACK-RESPONSE": "Collecte des données",
            "UPLOAD": "Envoi des résultats à l’IB",
            "UPLOAD-PROGRESS": "[Upload Progress]",
            "OFFLINE-INIT": "Traitement en cours"
          }
        },
        "USER-DATA": {
          "DESCRIPTION": [
            "Le logiciel Compatibility Checker permet de déterminer si cet appareil possède la configuration de base requise pour les examens sur ordinateur.",
            "Veuillez renseigner les champs ci-dessous et passer à l’étape {{nextStep}}.",
            "Les résultats de cette vérification seront enregistrés par l’IB, veuillez donc vérifier que le code de l’établissement est saisi correctement."
          ],
          "ERROR": {
            "REQUIRED-SCHOOL-CODE": "Veuillez saisir le code de votre établissement.",
            "VALID-MAIL": "Adresse électronique non valide",
            "VALID-SCHOOL-CODE": "Le code de l’établissement doit être composé de six chiffres. S’il en a moins, il doit être précédé par des zéros (par exemple : 001234)."
          },
          "INPUT-LABEL": {
            "EMAIL": "Adresse électronique",
            "NAME": "Nom",
            "SCHOOL-CODE": "Code de l’établissement"
          },
          "LABEL": "Renseignements concernant l’utilisateur"
        },
        "VIDEO-COMP-CHECK": {
          "DESCRIPTION": [
            "La vidéo ci-dessous devrait démarrer automatiquement. Vérifiez si vous pouvez la visionner et si le volume et l'image sont adéquats.",
            "Veuillez cliquer sur <strong>Succès</strong> ou <strong>Échec</strong>. Vous passerez ensuite automatiquement à l’étape {{nextStep}}."
          ],
          "FAILED-BTN": "Échec",
          "FAILED-MSG": "Vous avez indiqué que la vidéo n'a pas démarré correctement.",
          "LABEL": "Test vidéo",
          "SUCCESS-BTN": "Succès"
        }
    },
    "SPECIMEN-RESPONSE-UPLOAD": {
        "LABEL": "Chargement des réponses d’élève",
        "FILENAME": "Nom de fichier",
        "BUTTON-CLOSE-SESSION": "Fermer la session",
        "LOGIN": {
            "LABEL" : "Connexion",
            "ENTER-PASSWORD": "Saisir le mot de passe",
            "INVALID-LOGIN": "<strong>Le mot de passe saisi est incorrect. Veuillez réessayer.</strong>"
        },
        "SESSION": {
            "TITLE": "Chargement de fichier de réponses de l’IB",
            "EXPIRED": "Votre session a expiré.",
            "EXPIRED-TRY-AGAIN": "Veuillez vous reconnecter pour charger d’autres fichiers de réponses.",
            "ERROR": "Un problème est survenu lors de votre session.",
            "ERROR-TRY-AGAIN": "Veuillez vous reconnecter pour charger d’autres fichiers de réponses."
        },
        "IDENTIFICATION": {
            "LABEL" : "Identification",
            "FORM": {
                "NAME": "Veuillez saisir votre nom :",
                "EMAIL": "Veuillez saisir votre adresse électronique :",
                "EMAIL-CONFIRM": "Veuillez confirmer votre adresse électronique :",
                "SCHOOLCODE": "Veuillez saisir le code de votre établissement :",
                "BUTTON-CONFIRM": "Confirmer"
            },
            "FORM-PLACEHOLDER": {
                "NAME": "Nom",
                "EMAIL": "Adresse électronique",
                "SCHOOLCODE": "Code de l’établissement"
            },
            "FORM-VALIDATION": {
                "NAME": "Nom (obligatoire)",
                "EMAIL-REQUIRED": "Une adresse électronique valide est obligatoire.",
                "EMAIL-INVALID-FORMAT": "Une adresse électronique valide est obligatoire.",
                "EMAIL-DIVERGE": "Les adresses électroniques saisies sont différentes.",
                "SCHOOLCODE-REQUIRED": "Veuillez saisir le code numérique de votre établissement.",
                "SCHOOLCODE-INVALID": "Veuillez saisir le code numérique de votre établissement."
            },
            "INFO-BOX": {
                "MESSAGE": "Le lien de téléchargement des PDF sera envoyé à l’adresse électronique saisie ici."
            }
        },
        "UPLOAD": {
            "LABEL" : "Chargement",
            "UPLOAD-BOX": {
                "MESSAGE": "Déposez les fichiers de réponses ici ou cliquez sur ",
                "BUTTON-BROWSE": "Parcourir",
                "ONLY-RESPONSE-FILES": "Veuillez n’ajouter que les fichiers de type <strong>.ibresponse</strong>",
                "REMAINING": {
                    "SINGLE-FILE": "1 fichier restant",
                    "MULTIPLE-FILES": "{{ files }} fichiers restants"
                }
            },
            "QUEUE-BOX": {
                "SELECTED-FILES": "Fichiers sélectionnés :",
                "REJECTED-FILES": "Fichiers rejetés :",
                "BUTTON-UPLOAD": "Chargement"
            },
            "NO-IB-FILES": {
                "TITLE": "Chargement de fichier de réponses de l’IB",
                "MESSAGE": "Vous avez essayé de charger un type de fichier non valide. Tout fichier autre qu’un fichier de type .ibresponse sera exclu du processus final."
            },
            "UPLOAD-DONE": "Téléchargement terminé",
            "UPLOAD-CONFIRM-MESSAGE-DONE": "Tous les fichiers de réponses valides ont été chargés avec succès.",
            "UPLOAD-CONFIRM-MESSAGE-DONE-ADDITIONAL": "La page suivante contient de plus amples informations sur le processus de chargement.",
            "UPLOAD-CONFIRM-MESSAGE-ERROR": "Attention ! Certains fichiers n’ont pas été chargés : <br>",
            "PROGRESS-BARS": {
                "OVERALL": "Chargement de {{ s1 }}/{{ total }} fichier(s) .ibresponse"
            }
        },
        "PROGRESS": {
            "LABEL": "Progression"
        },
        "SUMMARY": {
            "LABEL" : "Résumé",
            "NO-FILES": {
                "ATTEMPTED": "Vous avez essayé de charger {{ files }} fichiers de réponses.",
                "MESSAGE": "Le ou les fichiers de réponses n’ont pas pu être chargés.",
                "MORE-INFO": "Veuillez réessayer ultérieurement."
            },
            "SINGLE-FILE": {
                "ATTEMPTED": "Vous avez essayé de charger 1 fichier de réponses.",
                "SUCCESS": "Le fichier de réponses a été chargé avec succès.",
                "MORE-INFO": "Vous recevrez un courriel contenant le lien de téléchargement des PDF, dans 30 à 60 minutes. Ce courriel sera envoyé à {{ email }}."
            },
            "MULTIPLE-FILES": {
                "ATTEMPTED": "Vous avez essayé de charger {{ files }} fichier(s) de réponses.",
                "SUCCESS": "<strong>{{ succededfiles }}</strong> fichiers de réponses ont été chargés avec succès.",
                "MORE-INFO": "Vous recevrez un courriel contenant le lien de téléchargement des PDF, dans 30 à 60 minutes. Ce courriel sera envoyé à {{ email }}."
            },
            "REJECTED": {
                "TITLE": "Fichiers rejetés",
                "FILENAME": "Nom de fichier"
            },
            "COULD-NOT-SAVE": "Un problème est survenu. Veuillez vérifier la connexion à Internet et réessayer."
        }
    },
    "NOT-AVAILABLE": "n/d",
    "DATE-FROM": "De:",
    "DATE-TO": "à:",
    "TIMEZONE-UTC": "UTC",
    DIALOGS_ERROR: "Erreur",
    DIALOGS_ERROR_MSG: "Une erreur inconnue s'est produite.",
    DIALOGS_CLOSE: "Fermer",
    DIALOGS_PLEASE_WAIT: "Veuillez patienter",
    DIALOGS_PLEASE_WAIT_ELIPS: "Veuillez patienter...",
    DIALOGS_PLEASE_WAIT_MSG: "En attente de l'exécution de l'opération.",
    DIALOGS_PERCENT_COMPLETE: "% achevé",
    DIALOGS_NOTIFICATION: "Notification",
    DIALOGS_NOTIFICATION_MSG: "Notification d'une application inconnue",
    DIALOGS_CONFIRMATION: "Confirmation",
    DIALOGS_CONFIRMATION_MSG: "Confirmation requise.",
    DIALOGS_OK: "OK",
    DIALOGS_YES: "Oui",
    DIALOGS_NO: "Non"
}
